import { useEffect } from 'react'
import './StepDrawer.css'

export default function StepDrawer({ title, onClose, children }) {
  useEffect(() => {
    const onEsc = (e) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onEsc)
    return () => window.removeEventListener('keydown', onEsc)
  }, [onClose])

  return (
    <>
      <div className="onb-drawer-backdrop" onClick={onClose} />
      <aside className="onb-drawer" role="dialog" aria-modal="true">
        <header className="onb-drawer-head">
          <h3>{title}</h3>
          <button onClick={onClose} aria-label="Close">×</button>
        </header>
        <div className="onb-drawer-body">{children}</div>
      </aside>
    </>
  )
}
